module.exports = __webpack_public_path__ + "static/media/cardano.9cfea3b8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/cardano.svg
// module id = 14
// module chunks = 0